// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"b542ebb4","344":"2c0c92c8","453":"e585caba"}[chunkId] + ".chunk.js";
};